import { Config } from '../../@types/plots';
import { transformFunctions, displayFunctions } from '../../utils/chartsUtils';
import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_4,
  ANALYTICS_COLOR_FACEBOOK,
  ANALYTICS_COLOR_FACEBOOK_GROUP,
  ANALYTICS_COLOR_GOOGLE,
  ANALYTICS_COLOR_INSTAGRAM,
  ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
  ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
  ANALYTICS_COLOR_PINTEREST,
  ANALYTICS_COLOR_POSTS,
  ANALYTICS_COLOR_TIKTOK_BUSINESS_PROFILE,
  ANALYTICS_COLOR_TIKTOK_PERSONAL_PROFILE,
  ANALYTICS_COLOR_TWITTER,
  ANALYTICS_COLOR_YOUTUBE,
  FACEBOOK,
  FACEBOOK_GROUP,
  GOOGLE,
  INSTAGRAM,
  LINKEDIN_BUSINESS_PAGE,
  LINKEDIN_PERSONAL_ACCOUNT,
  PINTEREST,
  TIKTOK_BUSINESS_PAGE,
  TIKTOK_PERSONAL_ACCOUNT,
  TWITTER,
  YOUTUBE
} from '../../config/constants';
import * as icons from '../../config/icons';
import {
  METRIC_FACEBOOK_PAGE_FANS,
  METRIC_GMB_VIEWS_MAPS,
  METRIC_GMB_VIEWS_SEARCH,
  METRIC_INSTAGRAM_FOLLOWER_COUNT,
  METRIC_INSTAGRAM_PROFILE_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_ALL_DESKTOP_PAGE_VIEWS_PAGE_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_ALL_MOBILE_PAGE_VIEWS_PAGE_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_TOTAL_LIKES,
  METRIC_TWITTER_ACCOUNT_FOLLOWERS_COUNT
} from '../../config/metrics';
import {
  DEMO_DATA_DASHBOARD_FOLLOWERS_FACEBOOK_PAGE,
  DEMO_DATA_DASHBOARD_FOLLOWERS_INSTAGRAM,
  DEMO_DATA_DASHBOARD_FOLLOWERS_LINKEDIN_BUSINESS_PAGE,
  DEMO_DATA_DASHBOARD_FOLLOWERS_TWITTER,
  DEMO_DATA_DASHBOARD_OVERVIEW_IMPRESSIONS,
  DEMO_DATA_DASHBOARD_OVERVIEW_REACTIONS,
  DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_FACEBOOK,
  DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_INSTAGRAM,
  DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_LINKEDIN_BUSINESS_PAGE,
  DEMO_DATA_DASHBOARD_POST_REACTIONS_FACEBOOK,
  DEMO_DATA_DASHBOARD_POST_REACTIONS_INSTAGRAM,
  DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_BUSINESS_PAGE,
  DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_PERSONAL_ACCOUNT,
  DEMO_DATA_DASHBOARD_POST_REACTIONS_TWITTER,
  DEMO_DATA_DASHBOARD_PROFILE_VIEW_GOOGLE,
  DEMO_DATA_DASHBOARD_PROFILE_VIEW_INSTAGRAM,
  DEMO_DATA_DASHBOARD_PROFILE_VIEW_LINKEDIN_BUSINESS_PAGE
} from '../../utils/demoDataUtils/demoDataArrays';
import {
  getLogDataPoints,
  getRandomDataPoints,
  getSinDataPoints,
  getStaticDataPoints
} from '../../utils/demoDataUtils/demoDataFunctions';

const filters = {
  filters: [
    // {
    //   css_icon: icons.STORY_POST_ICON,
    //   param: 'content_type_is_story_post',
    //   tooltip: 'content_type_is_story_post_ony'
    // },
    // {
    //   css_icon: icons.TEX_POST_ICON,
    //   param: 'content_type_is_text_post',
    //   tooltip: 'content_type_is_text_post'
    // },
    //
    // {
    //   css_icon: icons.SINGLE_IMAGE_POST_ICON,
    //   param: 'content_type_is_single_image_post',
    //   tooltip: 'content_type_is_single_image_post_ony'
    // },
    // {
    //   css_icon: icons.MULTI_IMAGE_POST_ICON,
    //   param: 'content_type_is_multi_image_post',
    //   tooltip: 'content_type_is_multi_image_post_ony'
    // },
    // {
    //   css_icon: icons.VIDEO_POST_ICON,
    //   param: 'content_type_is_video_post',
    //   tooltip: 'content_type_is_video_post_ony'
    // },
    // {
    //   css_icon: icons.REEL_POST_ICON,
    //   param: 'content_type_is_reel_post',
    //   tooltip: 'content_type_is_reel_post_ony'
    // }
  ]
};
export const config: Config = {
  shouldBeCached: true,
  ...filters,
  // bar_plot_config: {
  //     title: 'mixedChart.posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [
        71,
        72,
        73,
        74,
        75,
        76, // fb post impressions
        120,
        121,
        122,
        123,
        124,
        125, // fb post reactions
        217, // insta
        // nothing for google
        400, // twitter
        504,
        505,
        506,
        507,
        508,
        509, // METRIC_LINKEDIN_PERSONAL_ACCOUNT_CUMULATED_REACTIONS,
        604,
        605,
        606,
        607,
        608,
        609 // METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_REACTIONS
      ],
      title: 'mixedChart.reactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_OVERVIEW_REACTIONS
        }
      }
    },
    // {
    //   metrics: [100007, 100008, 100011, 100013],
    //   title: 'mixedChart.followers',
    //   iconCssClass: 'optional value',
    //   hexColor: ANALYTICS_COLOR_GREEN,
    //   type: 'line',
    //   platform: 'true'
    // },
    {
      metrics: [
        33,
        108, // METRIC_FACEBOOK_CUMULATED_IMPRESSIONS,
        207, // METRIC_INSTAGRAM_CUMULATED_IMPRESSIONS,
        17, // METRIC_GOOGLE_CUMULATED_IMPRESSIONS,
        // not available METRIC_TWITTER_CUMULATED_IMPRESSIONS,
        // METRIC_LINKEDIN_PERSONAL_ACCOUNT_CUMULATED_IMPRESSIONS,
        613 // METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_REACTIONS
      ],
      title: 'mixedChart.impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_OVERVIEW_IMPRESSIONS
        }
      }
    }
  ]
};
export const configProfileImpressions: Config = {
  ...filters,
  // bar_plot_config: {
  //     title: 'mixedChart.posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    // {
    //     metrics: [METRIC_FACEBOOK_PAGE_TOTAL_PAGE_VIEWS],
    //     title: FACEBOOK,
    //     iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
    //     hexColor: ANALYTICS_COLOR_FACEBOOK,
    //     type: 'line',
    //     platform: FACEBOOK,
    //     display: 'sum'
    // },
    {
      metrics: [METRIC_INSTAGRAM_PROFILE_VIEWS],
      title: INSTAGRAM,
      iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      platform: INSTAGRAM,
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_PROFILE_VIEW_INSTAGRAM
        }
      }
    },
    {
      metrics: [METRIC_GMB_VIEWS_MAPS, METRIC_GMB_VIEWS_SEARCH],
      title: GOOGLE,
      iconCssClass: icons.PLATFORM_ICONS[GOOGLE],
      hexColor: ANALYTICS_COLOR_GOOGLE,
      type: 'line',
      platform: GOOGLE,
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_PROFILE_VIEW_GOOGLE
        }
      }
    },
    {
      metrics: [
        METRIC_LINKEDIN_BUSINESS_PAGE_ALL_DESKTOP_PAGE_VIEWS_PAGE_VIEWS,
        METRIC_LINKEDIN_BUSINESS_PAGE_ALL_MOBILE_PAGE_VIEWS_PAGE_VIEWS
      ],
      title: LINKEDIN_BUSINESS_PAGE,
      iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',
      platform: LINKEDIN_BUSINESS_PAGE,
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_PROFILE_VIEW_LINKEDIN_BUSINESS_PAGE
        }
      }
    }
  ]
};

export const configProfileFollowers: Config = {
  ...filters,
  // bar_plot_config: {
  //   title: 'mixedChart.posts',
  //   iconCssClass: 'fas fab-facebook',
  //   hexColor: ANALYTICS_COLOR_YELLOW,
  //   type: 'bar'
  // },

  metrics: [
    {
      metrics: [METRIC_FACEBOOK_PAGE_FANS],
      title: FACEBOOK,
      iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',
      platform: FACEBOOK,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_FOLLOWERS_FACEBOOK_PAGE
        }
      }
    },
    {
      metrics: [METRIC_INSTAGRAM_FOLLOWER_COUNT],
      title: INSTAGRAM,
      iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      platform: INSTAGRAM,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_FOLLOWERS_INSTAGRAM
        }
      }
    },
    {
      metrics: [METRIC_TWITTER_ACCOUNT_FOLLOWERS_COUNT],
      title: TWITTER,
      iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',
      platform: TWITTER,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_FOLLOWERS_TWITTER
        }
      }
    },
    {
      metrics: [METRIC_LINKEDIN_BUSINESS_PAGE_TOTAL_LIKES],
      title: LINKEDIN_BUSINESS_PAGE,
      iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',
      platform: LINKEDIN_BUSINESS_PAGE,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_FOLLOWERS_LINKEDIN_BUSINESS_PAGE
        }
      }
    }
  ]
};

export const configEngagement: Config = {
  ...filters,
  // bar_plot_config: {
  //     title: 'mixedChart.posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [71, 72, 73, 74, 75, 76, 120, 121, 122, 123, 124, 125],
      title: FACEBOOK,
      iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_REACTIONS_FACEBOOK
        }
      }

      // platform: FACEBOOK
    },
    {
      metrics: [217],
      title: INSTAGRAM,
      iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_REACTIONS_INSTAGRAM
        }
      }
      // platform: INSTAGRAM
    },
    {
      metrics: [400],
      title: TWITTER,
      iconCssClass: icons.PLATFORM_ICONS[TWITTER],
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_REACTIONS_TWITTER
        }
      }
      // platform: TWITTER
    },
    {
      metrics: [504, 505, 506, 507, 508, 509],
      title: LINKEDIN_PERSONAL_ACCOUNT,
      iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_PERSONAL_ACCOUNT
        }
      }
      // platform: LINKEDIN_BUSINESS_PAGE
    },
    {
      metrics: [604, 605, 606, 607, 608, 609],
      title: LINKEDIN_BUSINESS_PAGE,
      iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_REACTIONS_LINKEDIN_BUSINESS_PAGE
        }
      }
      // platform: LINKEDIN_BUSINESS_PAGE
    }
  ]
};

export const configPostImpressions: Config = {
  ...filters,
  // bar_plot_config: {
  //     title: 'mixedChart.posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'a
  // },

  metrics: [
    {
      metrics: [33, 108],
      title: FACEBOOK,
      iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_FACEBOOK
        }
      }
      // platform: FACEBOOK
    },
    {
      metrics: [207],
      title: INSTAGRAM,
      iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_INSTAGRAM
        }
      }
      // platform: INSTAGRAM
    },
    // {
    //   metrics: [METRIC_TWITTER_CUMULATED_IMPRESSIONS],
    //   title: TWITTER,
    //   iconCssClass: icons.PLATFORM_ICONS[TWITTER],
    //   hexColor: ANALYTICS_COLOR_PINK_BLUSH,
    //   type: 'line',
    //     formula: 'delta',
    //     display: 'sum',
    //   platform: TWITTER
    // },
    // {
    //     metrics: [17],
    //     title: GOOGLE,
    //     iconCssClass: icons.PLATFORM_ICONS[GOOGLE],
    //     hexColor: ANALYTICS_COLOR_GOOGLE,
    //     type: 'line',
    //     formula: 'delta',
    //     display: 'sum',
    //     //platform: LINKEDIN_BUSINESS_PAGE
    // },
    // {
    //     metrics: [513],
    //     title: LINKEDIN_PERSONAL_ACCOUNT,
    //     iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
    //     hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
    //     type: 'line',
    //     formula: 'delta',
    //     display: 'sum',
    //     //platform: LINKEDIN_BUSINESS_PAGE
    // },
    {
      metrics: [613],
      title: LINKEDIN_BUSINESS_PAGE,
      iconCssClass: icons.PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_DASHBOARD_POST_IMPRESSIONS_LINKEDIN_BUSINESS_PAGE
        }
      }
      // platform: LINKEDIN_BUSINESS_PAGE
    }
  ]
};

export const configsMap: {
  overview: Config;
  profile_views: Config;
  post_reactions: Config;
  post_impressions: Config;
  followers: Config;
} = {
  overview: { ...config },
  post_impressions: { ...configPostImpressions },
  post_reactions: { ...configEngagement },
  followers: { ...configProfileFollowers },
  profile_views: { ...configProfileImpressions }
};

const platformConfigMap = {
  [FACEBOOK]: configsMap
};
export const getConfig = (
  key: ConfigKeys,
  platform: PlatformConfigKeys
): Config => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!platform) return configsMap[key];
  return platformConfigMap[platform][key];
};
export const getLabels = (platform: PlatformConfigKeys): any[] => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!platform) return Object.keys(configsMap);
  return Object.keys(platformConfigMap[platform]);
};
export type ConfigKeys = keyof typeof configsMap;
export type PlatformConfigKeys = keyof typeof platformConfigMap;

// ------------------------------------------------------------

export const newConfigsMap: any = {
  overview: {
    addAdditionalPlots: true,

    impressions: {
      title: 'mixedChart.impressions',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      // infoMessage: 'this_is_test_message',

      display: displayFunctions.sum
    },
    reach: {
      title: 'mixedChart.reach',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',

      display: displayFunctions.sum
    },
    reactions: {
      title: 'mixedChart.reactions',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  post_reactions: {
    addAdditionalPlots: true,

    facebook: {
      title: 'mixedChart.facebook',
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',

      display: displayFunctions.sum
    },
    instagram: {
      title: 'mixedChart.instagram',
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',

      display: displayFunctions.sum
    },
    twitter: {
      title: 'mixedChart.twitter',
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_BUSINESS_PAGE]: {
      title: LINKEDIN_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',

      display: displayFunctions.sum
    },
    [TIKTOK_PERSONAL_ACCOUNT]: {
      title: TIKTOK_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_TIKTOK_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [TIKTOK_BUSINESS_PAGE]: {
      title: TIKTOK_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_TIKTOK_BUSINESS_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [YOUTUBE]: {
      title: YOUTUBE,
      hexColor: ANALYTICS_COLOR_YOUTUBE,
      type: 'line',
      display: displayFunctions.sum
    },
    [PINTEREST]: {
      title: PINTEREST,
      hexColor: ANALYTICS_COLOR_PINTEREST,
      type: 'line',
      display: displayFunctions.sum
    }
  },
  post_reach: {
    addAdditionalPlots: true,
    facebook: {
      title: 'mixedChart.facebook',
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',

      display: displayFunctions.sum
    },
    facebook_group: {
      title: 'mixedChart.facebook_group',
      hexColor: ANALYTICS_COLOR_FACEBOOK_GROUP,
      type: 'line',
      display: displayFunctions.sum
    },
    instagram: {
      title: 'mixedChart.instagram',
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      infoMessage: 'instagram_profile_followers_info',
      display: displayFunctions.sum
    },
    twitter: {
      title: 'mixedChart.twitter',
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',

      display: displayFunctions.sum
    },
    [GOOGLE]: {
      title: 'mixedChart.google',
      hexColor: ANALYTICS_COLOR_GOOGLE,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_BUSINESS_PAGE]: {
      title: LINKEDIN_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [YOUTUBE]: {
      title: YOUTUBE,
      hexColor: ANALYTICS_COLOR_YOUTUBE,
      type: 'line',
      display: displayFunctions.sum
    },
    [PINTEREST]: {
      title: PINTEREST,
      hexColor: ANALYTICS_COLOR_PINTEREST,
      type: 'line',
      display: displayFunctions.sum
    }
  },
  // reach: {
  //   addAdditionalPlots: true,
  //
  //   instagram: {
  //     title: 'mixedChart.instagram',
  //     hexColor: ANALYTICS_COLOR_INSTAGRAM,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   facebook: {
  //     title: 'mixedChart.facebook',
  //     hexColor: ANALYTICS_COLOR_FACEBOOK,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   [LINKEDIN_BUSINESS_PAGE]: {
  //     title: LINKEDIN_BUSINESS_PAGE,
  //     hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
  //     type: 'line',
  //     display: displayFunctions.sum
  //   },
  //
  //   google: {
  //     title: 'mixedChart.google',
  //     hexColor: ANALYTICS_COLOR_GOOGLE,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   twitter: {
  //     title: 'mixedChart.twitter',
  //     hexColor: ANALYTICS_COLOR_TWITTER,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   }
  // },
  // impressions: {
  //   addAdditionalPlots: true,
  //
  //   instagram: {
  //     title: 'mixedChart.instagram',
  //     hexColor: ANALYTICS_COLOR_INSTAGRAM,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   facebook: {
  //     title: 'mixedChart.facebook',
  //     hexColor: ANALYTICS_COLOR_FACEBOOK,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   [LINKEDIN_BUSINESS_PAGE]: {
  //     title: LINKEDIN_BUSINESS_PAGE,
  //     hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
  //     type: 'line',
  //     display: displayFunctions.sum
  //   },
  //
  //   google: {
  //     title: 'mixedChart.google',
  //     hexColor: ANALYTICS_COLOR_GOOGLE,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   },
  //   twitter: {
  //     title: 'mixedChart.twitter',
  //     hexColor: ANALYTICS_COLOR_TWITTER,
  //     type: 'line',
  //
  //     display: displayFunctions.sum
  //   }
  // },
  post_impressions: {
    addAdditionalPlots: true,

    instagram: {
      title: 'mixedChart.instagram',
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',

      display: displayFunctions.sum
    },
    facebook: {
      title: 'mixedChart.facebook',
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_BUSINESS_PAGE]: {
      title: LINKEDIN_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',
      display: displayFunctions.sum
    },
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    twitter: {
      title: 'mixedChart.twitter',
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',

      display: displayFunctions.sum
    },
    [TIKTOK_PERSONAL_ACCOUNT]: {
      title: TIKTOK_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_TIKTOK_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [TIKTOK_BUSINESS_PAGE]: {
      title: TIKTOK_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_TIKTOK_BUSINESS_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [YOUTUBE]: {
      title: YOUTUBE,
      hexColor: ANALYTICS_COLOR_YOUTUBE,
      type: 'line',
      display: displayFunctions.sum
    },
    [PINTEREST]: {
      title: PINTEREST,
      hexColor: ANALYTICS_COLOR_PINTEREST,
      type: 'line',
      display: displayFunctions.sum
    }
  },
  profile_followers: {
    addAdditionalPlots: false,
    facebook: {
      title: 'mixedChart.facebook',
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',

      display: displayFunctions.lastValue
    },
    instagram: {
      title: 'mixedChart.instagram',
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      infoMessage: 'instagram_profile_followers_info',

      display: displayFunctions.lastValue
    },
    twitter: {
      title: 'mixedChart.twitter',
      hexColor: ANALYTICS_COLOR_TWITTER,
      type: 'line',

      display: displayFunctions.lastValue
    },
    [LINKEDIN_BUSINESS_PAGE]: {
      title: LINKEDIN_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',

      display: displayFunctions.lastValue
    },
        [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.lastValue
    },
    [TIKTOK_PERSONAL_ACCOUNT]: {
      title: TIKTOK_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_TIKTOK_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.lastValue
    },
    [TIKTOK_BUSINESS_PAGE]: {
      title: TIKTOK_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_TIKTOK_BUSINESS_PROFILE,
      type: 'line',

      display: displayFunctions.lastValue
    },
    [YOUTUBE]: {
      title: YOUTUBE,
      hexColor: ANALYTICS_COLOR_YOUTUBE,
      type: 'line',
      display: displayFunctions.lastValue
    },
    [PINTEREST]: {
      title: PINTEREST,
      hexColor: ANALYTICS_COLOR_PINTEREST,
      type: 'line',
      display: displayFunctions.lastValue
    }
  },
  profile_views: {
    addAdditionalPlots: false,

    instagram: {
      title: 'mixedChart.instagram',
      hexColor: ANALYTICS_COLOR_INSTAGRAM,
      type: 'line',
      infoMessage: 'instagram_profile_followers_info',

      display: displayFunctions.sum
    },
    facebook: {
      title: 'mixedChart.facebook',
      hexColor: ANALYTICS_COLOR_FACEBOOK,
      type: 'line',

      display: displayFunctions.sum
    },
    [LINKEDIN_BUSINESS_PAGE]: {
      title: LINKEDIN_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_LINKEDIN_BUSINESS_PAGE,
      type: 'line',

      display: displayFunctions.sum
    },
    [GOOGLE]: {
      title: GOOGLE,
      hexColor: ANALYTICS_COLOR_GOOGLE,
      type: 'line',
      infoMessage: 'mixedChart.google_info',
      display: displayFunctions.sum
    },
    [TIKTOK_PERSONAL_ACCOUNT]: {
      title: TIKTOK_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_TIKTOK_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [TIKTOK_BUSINESS_PAGE]: {
      title: TIKTOK_BUSINESS_PAGE,
      hexColor: ANALYTICS_COLOR_TIKTOK_BUSINESS_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    },
    [YOUTUBE]: {
      title: YOUTUBE,
      hexColor: ANALYTICS_COLOR_YOUTUBE,
      type: 'line',
      display: displayFunctions.sum
    },
    [PINTEREST]: {
      title: PINTEREST,
      hexColor: ANALYTICS_COLOR_PINTEREST,
      type: 'line',
      display: displayFunctions.sum
    }
  },

  posts_per_day_plot: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day_plot',
    border: 4,
    posts_per_day_plot: {
      normalizeValues: true,
      title: 'mixedChart.posts_per_day_plot',
      hexColor: ANALYTICS_COLOR_POSTS,
      type: 'bar',
      display: displayFunctions.sum
    }
  },
  posts_per_day: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
  }
};

export const configmapForLinkedinPersonalOnly: any = {
  overview: {
    addAdditionalPlots: false,
    impressions: {
      title: 'mixedChart.impressions',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      // infoMessage: 'this_is_test_message',

      display: displayFunctions.sum
    },
    reach: {
      title: 'mixedChart.reach',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',

      display: displayFunctions.sum
    },
    reactions: {
      title: 'mixedChart.reactions',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  post_reactions: {
    addAdditionalPlots: false,

    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  post_reach: {
    addAdditionalPlots: false,
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  post_impressions: {
    addAdditionalPlots: false,
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  profile_followers: {
    addAdditionalPlots: false,
    [LINKEDIN_PERSONAL_ACCOUNT]: {
      title: LINKEDIN_PERSONAL_ACCOUNT,
      hexColor: ANALYTICS_COLOR_LINKEDIN_PERSONAL_PROFILE,
      type: 'line',

      display: displayFunctions.lastValue
    }
  }
};

const dashboardConfig = {
  overview: [FACEBOOK, INSTAGRAM, LINKEDIN_BUSINESS_PAGE, LINKEDIN_PERSONAL_ACCOUNT],
  post_reactions: [FACEBOOK, INSTAGRAM, LINKEDIN_BUSINESS_PAGE, LINKEDIN_PERSONAL_ACCOUNT],
  post_reach: [FACEBOOK, INSTAGRAM, LINKEDIN_BUSINESS_PAGE, LINKEDIN_PERSONAL_ACCOUNT],
  post_impressions: [FACEBOOK, INSTAGRAM, LINKEDIN_BUSINESS_PAGE, LINKEDIN_PERSONAL_ACCOUNT],
  profile_followers: [FACEBOOK, INSTAGRAM, TWITTER, LINKEDIN_BUSINESS_PAGE, LINKEDIN_PERSONAL_ACCOUNT],
  profiles_views: [FACEBOOK, INSTAGRAM, GOOGLE, LINKEDIN_BUSINESS_PAGE],
  posts_per_day: [
    FACEBOOK,
    INSTAGRAM,
    TWITTER,
    GOOGLE,
    LINKEDIN_BUSINESS_PAGE
  ],
  group_members: [FACEBOOK_GROUP]
};

export const getConfigForAvailablePlatforms = (config, platforms) => {
  let availablePlots = [];

  Object.keys(platforms)?.forEach((platform) => {
    if (platforms[platform] !== false) {
      Object.keys(dashboardConfig).forEach((plotName) => {
        if (dashboardConfig[plotName].includes(platform)) {
          availablePlots.push(plotName);
        }
      });
    }
  });

  availablePlots = [...new Set(availablePlots)]; // Remove duplicates if any

  const newConfig = {};
  Object.keys(config).forEach((plotName) => {
    if (availablePlots.includes(plotName)) {
      newConfig[plotName] = config[plotName];
    }
  });

  return newConfig;
};

export const OVERVIEW_LABEL = 'overview';
export const BEST_TIME_TO_POST_LABEL = 'bestTimeToPost';
export const GROWTH_LABEL = 'growth';
export const DEMOGRAPHICS_LABEL = 'demographics';
export const POST_PERFORMANCE_LABEL = 'postPerformance';
export const CAMPAIGN_ANALYTICS_LABEL = 'campaignAnalytics';

export const POSTS_ANALYTICS_LABEL = 'postsAnalytics';

export const ANALYTICS_NAVBAR_ACTIONS = [
  {
    label: OVERVIEW_LABEL,
    onClick: () => console.log('Overview clicked'),
    active: true,
    default: true
  },
  { label: GROWTH_LABEL, onClick: () => console.log('Growth clicked') },
  {
    label: BEST_TIME_TO_POST_LABEL,
    onClick: () => console.log('bestTimeToPost clicked')
  },
  {
    label: DEMOGRAPHICS_LABEL,
    onClick: () => console.log('demographics clicked')
  },
  {
    label: POST_PERFORMANCE_LABEL,
    onClick: () => console.log('post performance clicked')
  },
  {
    label: CAMPAIGN_ANALYTICS_LABEL,
    onClick: () => console.log('campaign analytics clicked')
  }
];

export const ANALYTICS_NAVBAR_ACTIONS_WITHOUT_GROWTH = [
  {
    label: OVERVIEW_LABEL,
    onClick: () => console.log('Overview clicked'),
    active: true,
    default: true
  },
  {
    label: BEST_TIME_TO_POST_LABEL,
    onClick: () => console.log('bestTimeToPost clicked')
  }
];

export const COMPETITOR_ANALYSIS = 'competitorAnalysis';
export const SOCIAL_FEEDS = 'socialFeeds';

export const COMPETITOR_ANALYTICS_NAVBAR_ACTIONS = [
  {
    label: COMPETITOR_ANALYSIS,
    onClick: () => console.log('competitorAnalysis clicked'),
    active: true,
    default: true
  },
  { label: SOCIAL_FEEDS, onClick: () => console.log('socialFeeds clicked') }
];

export const POSTS_ANALYTICS_NAVBAR_ACTIONS = [
  {
    label: POSTS_ANALYTICS_LABEL,
    onClick: () => console.log('postsAnalysis clicked'),
    active: true,
    default: true
  },
  {
    label: POST_PERFORMANCE_LABEL,
    onClick: () => console.log('postPerformance clicked')
  },
  {
    label: CAMPAIGN_ANALYTICS_LABEL,
    onClick: () => console.log('campaignAnalysis clicked')
  }
];

export const AD_CAMPAIGNS = 'adCampaigns';
export const AD_MANAGER = 'adManager';
export const AD_ANALYTICS_NAVBAR_ACTIONS = [
  {
    label: AD_CAMPAIGNS,
    onClick: () => console.log('adCampaign clicked'),
    active: true,
    default: true
  }
];
